import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 信息公开
 */
export class PublicInfoController {
    constructor() {
        this.baseurl = 'PublicInfoController.assx/';
    }
    /**
         * 获取公开信息
         * token:String, keyId:String
         */
    getReprotFillDraft(token){
        return request.post(this.baseurl + 'getReprotFillDraft', Qs.stringify({ token:token }));
    }
    /**
     * 获取公开信息
     * token:String, keyId:String
     */
    getPublicInfoData(token, keyId){
        return request.post(this.baseurl + 'getPublicInfoData', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 获取公开信息的映射
     * token:String, keyId:String
     */
    getPublicInfoDataTurn2Map(token, keyId){
        return request.post(this.baseurl + 'getPublicInfoDataTurn2Map', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 作废公开信息
     * token:String, keyId:String
     */
    // dropPublicInfo(token, keyId){
    //     return request.post(this.baseurl + 'dropPublicInfo', Qs.stringify({ token:token, keyId:keyId }));
    // }
    dropPublicInfo(token, keyId,option){
        return request.post(this.baseurl + 'dropPublicInfo', Qs.stringify({ token: token, keyId: keyId, option: option }));
    }

    /**
     * 获取时间范围
     * token:String, keyId:String
     */
    getTimeRange(token, keyId){
        return request.post(this.baseurl + 'getTimeRange', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 添加公开信息
     * token:String, templateName:String, data:String, importantDocs:ImportantDocList, ReportTypes:String, timeRange:String, reportingYear:String
     */
    addPublicInfo(token, templateName, data, importantDocs, ReportTypes, timeRange, reportingYear,isDraft,attachmentId){
        return request.post(this.baseurl + 'addPublicInfo', Qs.stringify({ token:token, templateName:templateName, data:data, importantDocs:(typeof importantDocs === 'undefined' || importantDocs === null) ? '' : importantDocs.toString(), ReportTypes:ReportTypes, timeRange:timeRange, reportingYear:reportingYear,isDraft:isDraft,attachmentId:attachmentId }));
    }

    /**
     * 查询公开信息列表
     * token:String, param:ReprotFillQueryPara, startIndex:int, maxSize:int, resultTotalCount:boolean, isPage:boolean
     */
    getPublicReportFillList(token, param, startIndex, maxSize, resultTotalCount, isPage){
        return request.post(this.baseurl + 'getPublicReportFillList', Qs.stringify({ token:token, param:(typeof param === 'undefined' || param === null) ? '' : param.toString(), startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount, isPage:isPage }));
    }

    /**
     * 通过社区获取小区
     * @param {*} token 
     * @param {*} communityCode 
     * @returns 
     */
    getEaAreaListByCommunityCode(token,communityCode){
      return request.post(this.baseurl + 'getEaAreaListByCommunityCode', Qs.stringify({ token:token, communityCode:communityCode}));
    }

    /**
     * 获取居代业公开信息
     * @param {*} token 
     * @param {*} keyId 
     * @param {*} templateName 
     * @returns 
     */
    getWaitingEmployPublicInfoData(token,keyId,templateName){
      return request.post(this.baseurl + 'getWaitingEmployPublicInfoData', Qs.stringify({ token:token, keyId:keyId,templateName:templateName}));
    }

    /**
     * 获取居代业管理列表数据
     * @param {*} token 
     * @param {*} eaAreaNme 
     * @param {*} eaAreaCode 
     * @param {*} streetCode 
     * @param {*} communityCode 
     * @param {*} committeeName 
     * @param {*} dataSource 
     * @param {*} busState 
     * @param {*} startIndex 
     * @param {*} maxSize 
     * @param {*} resultTotalCount 
     * @returns 
     */
    getWaitingEmployManageList(token, 
      eaAreaNme,eaAreaCode,streetCode,communityCode,committeeName,dataSource,busState,
      startIndex, maxSize, resultTotalCount){
      return request.post(this.baseurl + 'getWaitingEmployManageList',
       Qs.stringify({ token:token,eaAreaNme:eaAreaNme, eaAreaCode:eaAreaCode,streetCode:streetCode,communityCode:communityCode,committeeName:committeeName,dataSource:dataSource,busState:busState,
        startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount}));
    }

    /**
     * 通过街道代码获取住宅小区信息
     * @param {*} token 
     * @param {*} streetCode 
     * @returns 
     */
    getEaAreaListByStreetCode(token,streetCode){
      return request.post(this.baseurl + 'getEaAreaListByStreetCode', Qs.stringify({ token:token,streetCode:streetCode}));
    }

    /**
     * 根据物业区域代码获取业委会信息
     * @param {*} token 
     * @param {*} eaAreaCode 
     * @returns 
     */
    getOwnerTeamByEaArea(token,eaAreaCode){
      return request.post(this.baseurl + 'getOwnerTeamByEaArea', Qs.stringify({ token:token,eaAreaCode:eaAreaCode}));
    }

    /**
     * 新增居代业管理数据
     * @param {*} token 
     * @param {*} templateName 
     * @param {*} manage 
     * @param {*} solicitOpinions 
     * @param {*} appointBulletin 
     * @param {*} notStart 
     * @param {*} stopAppoint 
     * @returns 
     */
    addWaitingEmployBus(token,templateName,manage,solicitOpinions,appointBulletin,notStart,stopAppoint){
      return request.post(this.baseurl + 'addWaitingEmployBus',
       Qs.stringify({ token:token,templateName:templateName,manage:manage,solicitOpinions:solicitOpinions,appointBulletin:appointBulletin,notStart:notStart,stopAppoint:stopAppoint}));
    }

    /**
     * 修改居代业管理数据
     * @param {*} token 
     * @param {*} templateName 
     * @param {*} manage 
     * @param {*} solicitOpinions 
     * @param {*} appointBulletin 
     * @param {*} notStart 
     * @param {*} stopAppoint 
     * @returns 
     */
    modifyWaitingEmployBus(token,templateName,manage,solicitOpinions,appointBulletin,notStart,stopAppoint){
      return request.post(this.baseurl + 'modifyWaitingEmployBus',
       Qs.stringify({ token:token,templateName:templateName,manage:manage,solicitOpinions:solicitOpinions,appointBulletin:appointBulletin,notStart:notStart,stopAppoint:stopAppoint}));
    }

    /**
     * 查看居代业管理详情
     * @param {*} token 
     * @param {*} keyId 
     * @returns 
     */
    getWaitingEmployManageInfo(token,keyId){
      return request.post(this.baseurl + 'getWaitingEmployManageInfo', Qs.stringify({ token:token,keyId:keyId}));
    }

    /**
     * 根据机构代码获取用户列表
     * @param {*} token 
     * @param {*} keyId 
     * @returns 
     */
    getUserOfEmpowerment(token,orgCode){
      return request.post(this.baseurl + 'getUserOfEmpowerment', Qs.stringify({ token:token,orgCode:orgCode}));
    }

    /**
     * 获取该街道已提交居代业管理的物业区域
     * @param {*} token 
     * @param {*} templateName 
     * @param {*} streetCode 
     * @returns 
     */
    getEaAreaByReportName(token,templateName,streetCode){
      return request.post(this.baseurl + 'getEaAreaByReportName', Qs.stringify({ token:token,templateName:templateName,streetCode:streetCode}));
    }

    /**
     * 根据业务id获取已提交的报表数据
     * @param {*} token 
     * @param {*} busId 
     * @returns 
     */
    getReportDataByBusId(token,busId){
      return request.post(this.baseurl + 'getReportDataByBusId', Qs.stringify({ token:token,busId:busId}));
    }

    /**
     * 
     * @param {*} token 
     * @param {*} templateName 
     * @param {*} data 
     * @param {*} busId 
     * @returns 
     */
    addWaitingEmployPublicInfo(token,templateName,data,busId,fillWay){
      return request.post(this.baseurl + 'addWaitingEmployPublicInfo', Qs.stringify({ token:token,templateName:templateName,data:data,busId:busId,fillWay:fillWay}));
    }

    /**
     * 获取居代业公开信息
     * @param {*} token 
     * @param {*} keyId 
     * @returns 
     */
    getWaitingEmployPublicInfo(token,keyId){
      return request.post(this.baseurl + 'getWaitingEmployPublicInfo', Qs.stringify({ token:token,keyId:keyId}));
    }

    /**
     * 判断是否能进入下一流程和是否能编辑
     * @param {*} token 
     * @param {*} busId 
     * @param {*} busState 
     * @param {*} type 
     * @returns 
     */
    isNextProcessAndEdit(token,busId,busState,type){
      return request.post(this.baseurl + 'isNextProcessAndEdit', Qs.stringify({ token:token,busId:busId,busState:busState,type:type}));
    }
}